import { getAppApiRoutes } from "../../Global";
import { DeviceTypeFilterRequestModel } from "../../models/RequestModels";
import ResponseModel from "../../models/ResponseModel";
import { apiPost } from "../apiClient";

class DeviceTypeService {
  async getDeviceTypes(filter: DeviceTypeFilterRequestModel = {}): Promise<ResponseModel> {
    return apiPost(getAppApiRoutes.deviceType.getDeviceTypes, { filter });
  }
}

const service: DeviceTypeService = new DeviceTypeService();
export default service;
